import { useMemo } from 'react';
import { useQuery } from '@common-fe/common-fe';
import dayjs from 'dayjs';
import { toString } from 'lodash';

import { api } from '@/api';
import { Roles } from '@/common/constants';
import { API_URL, ILinkedApplicationUserResponseDto, IPageLinkedApplicationUserResponseDto } from '@/dtos';

export const GET_LINKED_APPLICATION_USERS_QUERY_KEY = 'GET_LINKED_APPLICATION_USERS';

export interface LinkedApplicationUser {
  applicationUserId?: string;
  username?: string;
  lastPasswordUpdate?: string;
  roleType?: Roles;
  isLoginLocked?: boolean;
  isMfaLocked?: boolean;
  mfaLockedTo?: string;
}

const formatUser = (user: ILinkedApplicationUserResponseDto): LinkedApplicationUser => {
  const mfaLockedTo = user.mfa_locked_to ? toString(user.mfa_locked_to) : undefined;

  return {
    applicationUserId: user.id !== undefined ? toString(user.id) : undefined,
    username: user.username,
    lastPasswordUpdate: user.last_password_update ? toString(user.last_password_update) : undefined,
    roleType: user.role as Roles,
    isLoginLocked: Boolean(user.is_locked_by_admin),
    isMfaLocked: Boolean(mfaLockedTo && dayjs(mfaLockedTo).isAfter(dayjs())),
    mfaLockedTo,
  };
};

const useLinkedApplicationUsersQuery = (linkId?: string) => {
  const { data, isLoading, isSuccess } = useQuery(
    [GET_LINKED_APPLICATION_USERS_QUERY_KEY, linkId],
    () => api.get<IPageLinkedApplicationUserResponseDto>(API_URL.APPLICATION_USERS_LINKED_BY_LINK_ID(linkId || '')),
    { enabled: Boolean(linkId) }
  );

  const formattedData = useMemo(
    () => (data?.data?.content || []).map(formatUser),
    [data],
  );

  return {
    formattedData,
    isLoading,
    isSuccess,
  };
};

export default useLinkedApplicationUsersQuery;
